import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import { recipes } from "@/design/recipes";
import "@/design/tokens.stylex";
import { colors, radii, space, text } from "@/design/tokens.stylex";

// Section tabs under a page title (Mercury's Banking | Books): quiet words, the
// current one on a soft pill. Use `tabProps` on a button or a router Link.

const styles = {
  list: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x3d5knr",
    k7Eaqz: "xeuugli",
    kXHlph: "xw2csxc",
    k5wCbM: "x1rohswg",
    $$css: true
  },
  tab: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "xsuxsxl",
    kZKoxP: "x10w6t97",
    kg3NbH: "xtft4pz",
    kMzoRj: "xc342km",
    kaIpWk: "x3kktt9",
    kWkggS: "xjbqb8w x1fns82p",
    kMwMTN: "x1i6qc9y xfpavck",
    kMv6JI: "xjb2p0i",
    kGuDYH: "xtu3avg",
    k63SB2: "xk50ysn",
    khDVqt: "xuxw1ft",
    kybGjl: "x1hl2dhg",
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  active: {
    kWkggS: "xlcwlql x1fns82p",
    kMwMTN: "xgwkh9f xfpavck",
    $$css: true
  }
};
export function TabList({
  children,
  "aria-label": ariaLabel,
  xstyle
}: {
  children: ReactNode;
  "aria-label": string;
  xstyle?: stylex.StyleXStyles;
}) {
  return <div role="tablist" aria-label={ariaLabel} {...stylex.props(styles.list, xstyle)}>
      {children}
    </div>;
}

/** The tab row's class names, for a list that is not a tablist (e.g. a nav of links). */
export function tabListProps(xstyle?: stylex.StyleXStyles) {
  return stylex.props(styles.list, xstyle);
}

/** Class names for one tab; spread onto a `<button role="tab">` or a `<Link>`. */
export function tabProps(active: boolean, xstyle?: stylex.StyleXStyles) {
  return stylex.props(styles.tab, recipes.focusRing, recipes.transition, active && styles.active, xstyle);
}